import { useEffect, useContext } from 'react'
import { useStorage } from 'hooks'
import { GeneralContext } from 'context'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Outlet } from 'layouts'
import {
  Captacao,
  Clientes,
  Colaboradores,
  CreatePassword,
  Dashboard,
  Demo,
  DocuSign,
  Financeiro,
  Login,
  Simulacao,
  Policy,
} from 'pages'
import PrivateRoute from 'layouts/PrivateRoute'
import RecoveryPassword from 'pages/RecoveryPassword'

const UserRoutes = () => {
  const [token] = useStorage('Token')
  const general = useContext(GeneralContext)

  useEffect(() => {
    // console.log('funciona caraio')
    // general.gestor.syncronize(token)
  }, [])

  return (
    <BrowserRouter>
      <Routes>
        {/* PUBLIC ROUTES */}
        <Route path="/login" element={<Login />} />
        <Route path="/new-password" element={<CreatePassword isNew />} />
        <Route path="/new-access" element={<CreatePassword />} />
        <Route path="/recovery-password" element={<RecoveryPassword />} />
        <Route path="docusign" element={<DocuSign />} />
        <Route path="/policy" element={<Policy />} />
        {/* PRIVATE ROUTES */}
        <Route path="/" element={<PrivateRoute />}>
          <Route path="" element={<Outlet />}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="clientes" element={<Clientes />} />
            <Route path="produtos" element={<Captacao />} />
            <Route path="financeiro" element={<Financeiro />} />
            <Route path="colaboradores" element={<Colaboradores />} />
            <Route path="demo" element={<Demo />} />
            {/* <Route path="*" element={<Demo />} /> */}
            {/* <Route path="simu" element={<Simulacao />} /> */}
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default UserRoutes
